import React, { PureComponent } from 'react';
import {
  Icon,
  IconButton,
  ListItemSecondaryAction,
  ListItemText,
  ListItemIcon,
  ListItemButton,
} from '@mui/material';

import withStyles from '@mui/styles/withStyles';

class ContactListItem extends PureComponent {
  handleClick = () => {
    const { onClick, contact, disableCall } = this.props;
    if (disableCall) onClick?.(contact);
    else window.location = `tel:${contact.phone}`;
  };

  handleDelete = () => {
    const { onDelete, contact } = this.props;
    onDelete?.(contact);
  };

  render() {
    const { classes, contact, disableCall, selected, onDelete, onEdit } =
      this.props;
    return (
      <ListItemButton
        dense
        divider
        selected={selected}
        onClick={this.handleClick}
      >
        {!!onEdit && (
          <IconButton
            aria-label="Delete"
            onClick={this.handleDelete}
            size="large"
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
        )}
        {!!onDelete && (
          <IconButton
            aria-label="Delete"
            onClick={this.handleDelete}
            size="large"
          >
            <Icon fontSize="small">delete</Icon>
          </IconButton>
        )}
        <ListItemText
          primary={contact.name}
          secondary={
            <div className={classes.secondaryText}>
              <span className={classes.secondaryTextItem}>
                {contact.position}
              </span>
              {!!contact.position && !!contact.company && (
                <span className={classes.secondaryTextBullet}>•</span>
              )}
              <span className={classes.secondaryTextItem}>
                {contact.company}
              </span>
              {(!!contact.position || !!contact.company) && !!contact.phone && (
                <span className={classes.secondaryTextBullet}>•</span>
              )}
              <span className={classes.secondaryTextItem}>{contact.phone}</span>
            </div>
          }
        />
        <ListItemSecondaryAction>
          {!disableCall && (
            <ListItemIcon
              classes={{
                root: classes.phoneIcon,
              }}
            >
              <IconButton
                size="small"
                aria-label="Call"
                href={`tel:${contact.phone}`}
              >
                <Icon>call</Icon>
              </IconButton>
            </ListItemIcon>
          )}
        </ListItemSecondaryAction>
      </ListItemButton>
    );
  }
}

const styles = theme => ({
  secondaryText: {
    // display: 'flex',
  },
  secondaryTextItem: {
    flex: '1 0 0%',
  },
  secondaryTextBullet: {
    margin: `0 ${theme.spacing(1)}`,
  },
  contactActions: {
    // display: 'flex',
    // justifyContent: 'center',
    textAlign: 'right',
  },
  phoneIcon: {
    minWidth: '0px',
  },
});

export default withStyles(styles)(ContactListItem);
